import { useForm } from "@tanstack/react-form"

import { PasswordFormField } from "@/components/PasswordFormField"
import { Button } from "@/components/ui/Button"

export function UpdatePasswordForm() {
  const form = useForm({
    defaultValues: {
      currentPassword: "",
      newPassword: "",
    },
  })

  return (
    <div className="tw-space-y-4">
      <h2 className="tw-text-lg tw-font-semibold tw-text-gray-900">
        Update Password
      </h2>

      <div className="tw-flex tw-flex-col tw-gap-6 md:tw-w-1/2 [&_label]:!tw-text-sm">
        <form.Field
          name="currentPassword"
          children={(field) => (
            <PasswordFormField field={field} label="Current Password" />
          )}
        />

        <form.Field
          name="newPassword"
          children={(field) => (
            <PasswordFormField field={field} label="New Password" />
          )}
        />
      </div>

      <div className="tw-flex tw-items-center tw-gap-4 tw-pt-2">
        <Button variant="default" disabled={true}>
          Change Password
        </Button>

        <Button
          variant="link"
          type="reset"
          className="tw-text-gray-600"
          onClick={(event) => {
            event.preventDefault()
            form.reset()
          }}
        >
          Clear
        </Button>
      </div>
    </div>
  )
}
